// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"3cf5154a","455":"822fbadc","977":"eff7130c"}[chunkId] + ".chunk.js";
};